// extracted by mini-css-extract-plugin
module.exports = {"icon":"Success_icon__3Pamd","BlackSuccessMessege":"Success_BlackSuccessMessege__3BDO_"};